export class AppSettings {
    public static BASE_URL = "https://woodscostarica-rest-api.herokuapp.com/";
}